import { FC } from "react";
import { TextField, TextFieldProps } from "@mui/material";
import { RegisterOptions, UseFormRegister } from "react-hook-form";

interface CustomTextFieldProps
  extends Omit<TextFieldProps, "variant" | "name" | "label"> {
  name: string;
  label: string;
  register: UseFormRegister<any>;
  rules?: RegisterOptions;
}

// Campo de texto padrão dos formulários (mesmo padrão do XC WMS)
const CustomTextField: FC<CustomTextFieldProps> = ({
  name,
  label,
  register,
  rules,
  InputLabelProps,
  ...props
}) => {
  const { onChange, onBlur, name: nomeCampo, ref } = register(name, rules);

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      size="small"
      InputLabelProps={{ shrink: true, ...InputLabelProps }}
      {...props}
      name={nomeCampo}
      inputRef={ref}
      onChange={onChange}
      onBlur={onBlur}
    />
  );
};

export default CustomTextField;
